import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('context', 'fetch-main-consent');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'appointments',
  type: 'get',
  slug: ['messaging_consents'],
});

export default createReqReducer(consts, true);



// WEBPACK FOOTER //
// ./src/redux/profiles/get-main-consent.js